import translate from "../../../i18n/translate";

interface ApiErrorProps {
  containerClasses?: string;
}

const link = <a href="https://support.watermarkinsights.com/hc/en-us/articles/11808042307739-Contacting-Watermark-s-Client-Support" target="_blank">{translate("app.apiError.contactSupportLink")}</a>;

export default function ApiError({
  containerClasses
}: ApiErrorProps): JSX.Element {
  return (
    <div className={containerClasses ? containerClasses : "error-response"}>
      <div>
        <span className="mdi mdi-cloud-off-outline cloud-icon" />
        <div className="error-response-sub-header">
          {translate("app.apiError.couldNotConnect")}
        </div>
        <div className="error-response-para">
          {translate("app.apiError.contactSupport", { element: link })}
        </div>
      </div>
    </div>
  );
}
